import React, { useCallback, useEffect } from "react";
import { CrfSingleSelectItemSpec } from "maven-lib/dist/consts/edc";
import { EcoaQuestionnaire } from "maven-lib/dist/dto/entity/ecoaVisit";
import { classNames } from "maven-lib/dist/utils/misc";
import { CrDropdown } from "@maven-surface/components/base/CrDropdown";
import { ECOA_CAPTURE_LANG } from "@maven-msg/lang/ecoaCapture";
import { MvnMessage } from "@maven-msg/lib/Message";

interface QuestionnaireDropdownSelectItemProps {
  className?: string;
  questionnaire: EcoaQuestionnaire;
  item: CrfSingleSelectItemSpec;
  disabled?: boolean;
  isAvailable?: boolean;
  defaultItemValues?: Array<{ itemId: string | null; dbVal: string | number | null }>;
  onValueChange: (values: Array<{ itemId: string | null; dbVal: string | number | null }>) => void;
}

export function QuestionnaireDropdownSelectItem({
  item,
  defaultItemValues,
  disabled,
  isAvailable = true,
  className,
  onValueChange,
}: QuestionnaireDropdownSelectItemProps) {
  const { codes } = item.itemCode;
  const dbVal = (defaultItemValues?.find((e) => e.itemId === item.id) || { itemId: null, dbVal: null }).dbVal;

  const handleChangeValue = useCallback(
    (val: string | number | null) => {
      onValueChange([{ itemId: item.id, dbVal: val }]);
    },
    [item.id, onValueChange]
  );

  useEffect(() => {
    if (!isAvailable && defaultItemValues?.length && dbVal !== null && !item.ecoa?.noSkipWhenDisabled) {
      handleChangeValue(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbVal, defaultItemValues, handleChangeValue, isAvailable]);

  return (
    <div className={classNames("hb-dropdown", className)}>
      <CrDropdown
        key={item.id}
        placeholder={item.placeholder ?? MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_PLACEHOLDER_SELECT)}
        defaultKey={dbVal || typeof dbVal === "number" ? dbVal : undefined}
        disabled={disabled}
        onValueChange={handleChangeValue}
        items={codes.map((code) => ({ key: code.dbVal, text: String(code.uiVal) }))}
      />
    </div>
  );
}
